import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { DataConnections } from '~src/connectivity/resources/DataConnections';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { DataConnectionInWorkbookContentType } from '~src/ts/models/ContentTypes';

import { getGenericDefaultFilters } from './getDefaultFilters';

// TFS 829184- these all need validating!
export const DataConnectionInDatasourceDefinition: ExplorableItemDefinition = {
  itemType: 'connection',
  pluralName: Messages.connections,
  singularName: Messages.connection,
  emptyStateMessage: Messages.connectionsEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['dataconnection']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return DataConnections.all().withExtraParams(DataConnectionInWorkbookContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
